
import HomeBannerList from '@/data/homeBanner/view/list.vue'
import homeBannerEditor from '@/data/homeBanner/view/editor.vue'

const list = {
  path: '/homeBanner',
  name: 'homeBanner-list',
  component: HomeBannerList
}
const creator = {
  path: '/homeBanner/creator',
  name: 'createHomeBanner',
  component: homeBannerEditor
}
const editor = {
  path: '/homeBanner/editor/:id(\\d+)',
  name: 'updateHomeBanner',
  component: homeBannerEditor
}

export default [list, creator, editor]
